import { render } from "./DemoForm.vue?vue&type=template&id=409ef298&scoped=true&ts=true"
import script from "./DemoForm.vue?vue&type=script&lang=ts"
export * from "./DemoForm.vue?vue&type=script&lang=ts"

import exportComponent from "/root/workspace/lll-ui_hccl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-409ef298"]])

export default __exports__